import { createTheme } from "@mui/material"
import { darken } from '@mui/material';

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#486376',
        },
        secondary: {
            main: '#3ab287',
            contrastText: '#f2f2f2',
        },
        background: {
            default: '#f2f2f2',
            paper: '#ffffff',
        },
        error: {
            main: '#e53935',
        },
    },
    typography: {
        htmlFontSize: 18,
        fontFamily: 'Lato',
    },
    components: {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottomColor: 'rgba(0, 0, 0, 0.12)',
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            }, 
            styleOverrides: {
                root: ({ theme }) => ({
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 8
                    })
            }      
        },
        MuiDialog: {
            styleOverrides: {
                paper: ({theme}) => ({
                    backgroundColor: theme.palette.background.default,
                    backgroundImage: "none", 
                }),
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: ({ theme }) => ({
                    backgroundColor: darken(theme.palette.background.paper, 0.01)
                }),
            },
        }
    }
})

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#678ea9',
        },
        secondary: {
            main: '#3ab287',
        },
        background: {
            default: '#1e2a31',
            paper: '#2b3c46',
        },
        text: {
            primary: '#dcf3ff',
            secondary: '#7996a9',
            disabled: 'rgba(121,150,169,0.3)',
        },
        error: {
            main: '#e53935',
        },
    },
    typography: {
        htmlFontSize: 18,
        fontFamily: 'Lato',
    },
    components: {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottomColor: 'rgba(255, 255, 255, 0.12)',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: ({theme}) => ({
                    backgroundColor: theme.palette.background.default,
                    backgroundImage: "none", 
                }),
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            }, 
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: ({ theme }) => ({
                     backgroundColor: darken(theme.palette.background.paper, 0.1)
                }),
            },
        }
    },
})